import {useState} from 'react';

import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import './Description.scss';
import useMediaQuery from 'hooks/useMediaQuery';

interface IProps {
  text: string;
  cutLength: number;
  ariaLabel?: string;
}

const Description = ({text, ariaLabel, cutLength}: IProps) => {
  const [shouldFormat, setShouldFormat] = useState(true);
  let shouldDisableFormat = false;

  const isDesktopScreen = useMediaQuery('(max-width: 992px)');
  const isSmallScreen = useMediaQuery('(min-width: 400px)');

  const isBetweenScreens = isSmallScreen && isDesktopScreen;

  const formatDetails = () => {
    const length = cutLength;

    const isWordLengthWiderThanPermitted = text?.length < length + 3;
    const shouldCutWord = isWordLengthWiderThanPermitted || !shouldFormat;

    if (shouldCutWord) {
      shouldDisableFormat = true;
      return text;
    }

    if (isBetweenScreens) {
      shouldDisableFormat = true;
      return text;
    }

    return `${text?.substr(0, length)}... `;
  };

  return (
    <div
      aria-label={ariaLabel || 'Description'}
      className={`description ${isBetweenScreens ? 'description--wider' : ''}`}
    >
      <div className="description__text">
        <div>
          <Text tag="pre" className="description__format">
            {formatDetails()}

            {!isBetweenScreens && (
              <>
                {shouldFormat && !shouldDisableFormat && (
                  <Button className="description__button" variant="link" onClick={() => setShouldFormat(false)}>
                    Read More
                  </Button>
                )}
                {!shouldFormat && shouldDisableFormat && (
                  <Button className="description__button" variant="link" onClick={() => setShouldFormat(true)}>
                    Show less
                  </Button>
                )}
              </>
            )}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default Description;
